<template>
  <form @submit.prevent="onsubmit" class="login">
    <div class="row mb-2 set-password__msg">
      Enter your new password
    </div>
    <div class="row mb-2">
      <va-input
        v-model="password1"
        type="password"
        label="New password"
        :error="!!passwordErrors1.length"
        :error-messages="passwordErrors1"
      />
    </div>
    <div class="row mb-2">
      <va-input
        v-model="password2"
        type="password"
        label="Repeat password"
        :error="!!passwordErrors2.length"
        :error-messages="passwordErrors2"
      />
    </div>

    <div class="row justify--center">
      <va-button type="submit" class="my-0">Change Password</va-button>
    </div>

    <div class="row set-password__done_msg" >
      <span v-if="showSent">
      Your password has been updated. <router-link class="ml-1 link" style="font-weight:bold;" :to="{name: 'login'}">Go to Login page.</router-link>
      </span>
    </div>

    <div class="row set-password__error" >
      <span v-if="showError">
        Reset code expired. Please<router-link class="ml-1 link set-password__link" :to="{name: 'recover-password'}">request a new one</router-link>.
      </span>
    </div>

  </form>
</template>

<script>
import hiqapi from '@/hiqapi/hiqapi'

export default {
  name: 'new-password',
  data() {
    return {
      password1: '',
      password2: '',
      passwordErrors1: [],
      passwordErrors2: [],
      showSent: false,
      showError: false,
    }
  },
  methods: {
    async onsubmit() {
      this.passwordErrors1 = []
      this.passwordErrors2 = []
      this.showSent = false
      this.showError = false

      if (this.password1.length < 12) {
        this.passwordErrors1 = ['Password must be at least 12 characters']
        return
      }
      if (this.password2 !== this.password1) {
        this.passwordErrors2 = ['Passwords must match']
        return
      }

      var pieces = this.$route.path.split('/')
      var resetCode = pieces[pieces.length - 1]
      console.log(resetCode, this.password1, this.password2)

      let resp = await hiqapi.postPutWait('put', '/users/' + resetCode, { 'password': this.password1 })
      console.log('BACK resp=', resp)

      if (resp.status === 200) {
        this.showSent = true
      } else {
        this.showError = true
      }
    },
  },
}
</script>

<style lang="scss">
.set-password {
  &__intro {
    padding-bottom: 30px;
  }
  &__msg {
    padding-bottom: 30px;
  }
  &__done_msg {
    padding-top: 30px;
  }
  &__error {
    font-weight:bold;
    color: red;
    height: 30px;
  }
  &__link {
    color: red !important;
    text-decoration: underline;
  }

}
</style>
